<template>
  <div>
    <Header ref="header" style="z-index: 9999" :title="title" :showBack="true"></Header>
    <van-cell title="签到" title-class="Title-CellClass" max-size>
      <van-uploader class="uploadBox" :after-read="onReadImg" accept="image/*" capture="camera" multiple
        :name="'aaaaaaaaaa'" ref="test">
        <span>点击拍照</span>
        <van-icon class="uploadIcon" name="photograph" />
      </van-uploader>
      <img :src="CheckImgPath" style="width: 90%" />
    </van-cell>
    <van-cell title="车辆" title-class="Title-CellClass" v-bind:value="VehicleNo" max-size></van-cell>
    <van-cell title="时间" title-class="Title-CellClass" v-bind:value="CheckInTime" max-size></van-cell>

    <van-button block type="primary" class="btn-test" @click="onCallCameraScan">扫码测试</van-button>
    <van-button block type="primary" class="btn-test" @click="onPostTest">请求测试</van-button>
    <van-cell title="扫码内容" title-class="Title-CellClass" :value="cameraScan" max-size></van-cell>

    <van-button block type="primary" class="btn-test" @click="onGetGPS">获取定位</van-button>
    <van-cell title="定位地址" title-class="Title-CellClass" :value="gpsAddress" max-size></van-cell>

    <van-button block type="primary" class="btn-test" @click="onChangeColor('orange')">更换颜色</van-button>

    <van-button block type="primary" class="btn-test" @click="onShowHealthCode">展示粤康码</van-button>

    <!-- 粤康码，穗康码信息展示 -->
    <health-info ref="healthInfo" :isSaveHealthInfo="false"></health-info>

    <!-- <van-button block type="primary" class="btn-test" @click="onTestAudio('nfc')">播放声音1</van-button>
    <van-button block type="primary" class="btn-test" @click="onTestAudio('check')">播放声音2</van-button>
    <van-button block type="primary" class="btn-test" @click="onTestAudio('err')">播放声音3</van-button>
    <van-button block type="primary" class="btn-test" @click="onTestAudio('all')">一次性播放声音测试1</van-button>
    <van-button block type="primary" class="btn-test" @click="onTestAudio('next')">一次性播放声音测试2</van-button>-->
  </div>
</template>
<script>
var successAudio = new Audio();
successAudio.src = require("../img/succeed.mp3");
successAudio.volume = 1; //取值范围[0-1]
var errAudio = new Audio();
errAudio.src = require("../img/error.wav");
errAudio.volume = 1; //取值范围[0-1]
var speechOnAudio = new Audio();
speechOnAudio.src = require("../img/ding.mp3");
speechOnAudio.volume = 1; //取值范围[0-1]

// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import healthInfo from "@/components/healthInfo.vue";

export default {
  components: {
    Header,
    'health-info': healthInfo
  },
  data() {
    return {
      title: "测试摄像头", //页面标题
      CheckImgPath: "",
      VehicleNo: "请对着车牌牌照，系统会自动识别",
      CheckInTime: "",
      latitude: "",
      longitude: "",
      cameraScan: "",
      gpsAddress: "",
      ticketList: [{
        // 24
        // CustCertNo: '452525196808140039',
        // CustName: '唐一飞'
        // 48
        // CustCertNo: '441827198806196018',
        // CustName: '白传斌'
        // 72
        // CustCertNo: '441802199708120260',
        // CustName: '区晓榆'
        // 7
        // CustCertNo: '513002200008059720',
        // CustName: '王熙'
        // 无
        // CustCertNo: '441823199611040012',
        // CustName: '黄天华'


        // 11:17分测试转为48小时
        // CustCertNo: '440227196607297016',
        // CustName: '彭加强'
        // CustCertNo: '441827199907078939',
        // CustName: '李和键'

        // 无核酸检测记录
        CustCertNo: '429006199104052194',
        CustName: '杨科科'
      }, {
        CustCertNo: '441827199907078939',
        CustName: '李和键'
      }, {
        CustCertNo: '441823199611040012',
        CustName: '黄天华'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    // 设置wx.config
    // this.$utils.setWXConfig().then((res) => {
    //   alert(JSON.stringify(res))
    // }).catch((err) => {
    //   alert(JSON.stringify(err))
    // });

    this.$refs.test.$el
      .getElementsByTagName("input")[0]
      .setAttribute("name", "车牌拍照");

    var that = this;
    // var fun = function (scanResult) {
    //   that.cameraScan = scanResult;
    // };
    // // 扫码回调
    // window.callCameraScan = fun.bind(this);

    var gpsfun = function (jsonObj) {
      //alert(1)
      //定位失败
      if (!jsonObj.success) {
        that.$toast.fail("获取手持机定位失败!");
        return;
      }
      let position = {
        coords: {
          latitude: jsonObj.data.latitude,
          longitude: jsonObj.data.longitude,
        },
      };
      that.onGetGPSSuccess(position);
    };
    // 定位回调
    window.callGeolocation = gpsfun.bind(this);


    // 定位回调
    var healthInfofun = function (obj) {
      alert(JSON.stringify(obj))
    }
    window.callHealthInfoByIdCard = healthInfofun.bind(this);
  },
  methods: {
    onPostTest() {
      this.$http
        .post(this.$api.onTicketOrderPayDo, {
          model: {
            OperCode: "test007",
            OperGID: "766a3230-b96c-495e-93b3-90d79f7b5f30",
            OperName: "验票测试",
            OrderNo: "TK2022011828",
            PayTypeCode: "AllinpayScanPayBSC",
          },
          authcode: "136241017881327653",
        })
        .then((res) => {
          if (res.success) {
            this.$toast("支付成功");
            //刷新界面 同时重新调用扫码
            this.reloadBtnClick();
            var that = this;
            setTimeout(function () {
              that.onFaseSeatBtnClick();
            }, 2000);
          } else {
            this.$toast("支付失败");
          }
        })
        .catch((err) => { });
    },
    onChangeColor(color) {
      console.log(color);
      //console.log(window.less);
      // window.less
      //   .modifyVars({
      //     // 'orange': "red",
      //   })
      //   .then(() => {
      //     console.log(1);
      //   })
      //   .catch((err) => {
      //     console.log(2, err);
      //   });
    },
    //检查坐标
    checkPhoneGPS(position) {
      this.phoneGPS = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      console.log(position);
      this.gpsAddress =
        position.coords.latitude + "," + position.coords.longitude;
      //alert(position.coords.latitude + "," + position.coords.longitude);
      // if (this.updateNodeGis) {
      //   this.updateNodeInfo(position);
      //   return;
      // }
      // let long = this.getFlatternDistance(
      //   this.phoneGPS.latitude,
      //   this.phoneGPS.longitude,
      //   this.nodeGis.lat,
      //   this.nodeGis.lng
      // );
      // console.log(long);
      //林和C 113.324285,23.140844   23.0812,113.2571
      // if (long >= 2000) {
      //   this.onSaveonSignInErrorRecord(
      //     1,
      //     null,
      //     "当前用户距离站点距离超过2千米,定位差距为" + long + "米",
      //     1
      //   );
      //   return;
      // }
      //3.获取车辆定位
      //this.onConwinVehicleQuery(this.checkVehicle);
    },
    //获取移动端定位成功
    onGetGPSSuccess(position) {
      var that = this;
      var gps = [position.coords.longitude, position.coords.latitude];
      //如果是手机获取 需要转码
      if (!window.framework) {
        // eslint-disable-next-line
        AMap.convertFrom(gps, "gps", function (status, result) {
          if (result.info === "ok") {
            let positions = {
              coords: {
                latitude: result.locations[0].lat,
                longitude: result.locations[0].lng,
              },
            };
            console.log("转码成功:" + JSON.stringify(positions));
            that.checkPhoneGPS(positions);
            //that.updateNodeInfo(positions);
            //return positions;
          }
        });
        return;
      } else {
        that.checkPhoneGPS(position);
        //that.updateNodeInfo(position);
      }
    },
    //定位数据获取失败响应
    onGetGPSError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert("您拒绝对获取地理位置的请求");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("位置信息是不可用的");
          break;
        case error.TIMEOUT:
          alert("请求您的地理位置超时");
          break;
        case error.UNKNOWN_ERROR:
          alert("未知错误");
          break;
        default:
          alert("获取设备定位失败");
          break;
      }
    },
    onGetGPS() {
      if (window.framework) {
        // 请求机器定位
        window.framework.jsGeolocation();
      } else {
        //非手持机 调用网页端获取机器定位
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            this.onGetGPSSuccess,
            this.onGetGPSError,
            {
              enableHighAcuracy: false, //位置是否精确获取
              timeout: 5000, //获取位置允许的最长时间
              //maximumAge: 1000, //多久更新获取一次位置
            }
          );
        } else {
          alert("您的浏览器不支持获取地理位置服务");
        }
      }
    },
    // changName() {
    //   this.$refs.test.$el
    //     .getElementsByTagName("input")[0]
    //     .setAttribute("name", "车牌拍照");
    // },
    onCallCameraScan() {
      var that = this;
      var fun = function (scanResult) {
        that.cameraScan = scanResult;
      };
      this.$utils
        .scanQRCode(fun)
        .then((res, type) => {
          console.log("扫码回调", res, type);
          var a = res.resultStr;
          this.$toast(
            "扫码成功".concat("，条码：", a, "返回对象", JSON.stringify(res))
          );
          if (type == "Fast") {
            // this.isFastPay = true;
          } else {
            // that.onCreatFastOrder(a, ticketType);
          }
        })
        .catch((err) => {
          this.$toast(JSON.stringify(err));
        });
      //获取wxJsAPI
      // this.$http
      //   .post(
      //     "https://wx.open.class.busboss.cn/Weixin/JSAPI",
      //     this.$qs.stringify({
      //       url: encodeURIComponent(window.location.href.split("#")[0]),
      //       AppID: "wx5e2cde762ffa2228",
      //     })
      //   )
      //   .then((res) => {
      //     let JsSDKConfig = res;
      //     console.log(JsSDKConfig);
      //     // eslint-disable-next-line no-undef
      //     wx.config({
      //       // debug : false,
      //       debug: false,
      //       appId: JsSDKConfig.appId,
      //       timestamp: parseInt(JsSDKConfig.timestamp),
      //       nonceStr: JsSDKConfig.noncestr,
      //       signature: JsSDKConfig.signature,
      //       jsApiList: ["scanQRCode"],
      //     });
      //     // eslint-disable-next-line no-undef
      //     wx.ready(() => {
      //       // eslint-disable-next-line no-undef
      //       wx.scanQRCode({
      //         needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      //         scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      //         success: function (codeRes) {
      //           var qrCode = codeRes.resultStr; // 当needResult 为 1 时，扫码返回的结果
      //           alert(qrCode);
      //         },
      //         fail: (err) => {
      //           console.log(err);
      //         },
      //       });
      //     });
      //   });
      // if (!window.framework) {
      //   alert("未识别到有效方法");
      //   return;
      // }
      // window.framework.jsCameraScan();
    },
    onReadImg(file) {
      //仅回调显示选择的图片 不上传 在车辆签到操作时才将图片转换并上传
      // this.LineClassDayVehicleDriverList[this.index].CheckImgPath =
      //   file.content;
      var postParm = {};
      console.log(file);
      // 大于1MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1000000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 400;
          canvas.height = 300;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 400, 300);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);

          // 最后将base64编码的图片保存，留待上传。
          postParm = {
            imgBase64: file.content,
          };
          this.onUploadImg(postParm);
        };
      } else {
        // 最后将base64编码的图片保存，留待上传。
        postParm = {
          imgBase64: file.content,
        };
        this.onUploadImg(postParm);
      }
    },
    onUploadImg: function (param) {
      this.$http
        .post(this.$api.NewLicensePlateOCR, this.$qs.stringify(param))
        .then((res) => {
          if (res.success) {
            console.log(res);
            // 最后将base64编码的图片保存，留待上传。
            this.CheckImgPath = param.imgBase64;
            this.VehicleNo = res.data.VehicleNo;
            this.CheckInTime = this.$moment().format("YYYY-MM-DD hh:mm:ss");
            //let checkNoList = '粤AM9999'.split("");
            //let noList = "粤AM9431".split("");
            //判断车牌号是否一致
            // var countTrue = 0;
            // noList.forEach((item) => {
            //   for (let i = 0; i < checkNoList.length; i++) {
            //     let stringNo = checkNoList[i];
            //     if (item == stringNo) {
            //       countTrue++;
            //       checkNoList.splice(i, 1);
            //       break;
            //     }
            //   }
            // });
            // console.log(countTrue);
            // if (countTrue < 5) {
            //   alert("正确率小于五位");
            // } else {
            //   alert("正确率大于五位");
            // }

            if (window.framework) {
              // 请求机器定位
              window.framework.jsGeolocation();

              var fun = function (jsonObj) {
                console.log(jsonObj);
                //定位失败
                if (!jsonObj.success) {
                  this.$toast.fail("定位失败!");
                  return;
                }
                //经度
                this.latitude = jsonObj.data.latitude;
                //纬度
                this.longitude = jsonObj.data.longitude;
              };
              // 定位回调
              window.callGeolocation = fun.bind(this);
            }
          }
        });
    },
    onTestAudio(type) {
      // var a= this.$refs.test //.getElementsByTagName('input')
      // debugger
      //console.log(a)
      switch (type) {
        case "nfc":
          speechOnAudio.play();
          break;
        case "check":
          successAudio.play();
          break;
        case "err":
          errAudio.play();
          break;
        case "all":
          speechOnAudio.play();
          setTimeout(function () {
            successAudio.play();
            setTimeout(function () {
              errAudio.play();
            }, 1500);
          }, 1500);

          break;
        case "next":
          var testAudio = new Audio();
          testAudio.volume = 1; //取值范围[0-1]
          testAudio.src = require("../img/succeed.mp3");
          testAudio.play();

          setTimeout(function () {
            testAudio.src = require("../img/error.wav");
            testAudio.play();
            setTimeout(function () {
              testAudio.src = require("../img/ding.mp3");
              testAudio.play();
            }, 1500);
          }, 1500);

          break;
      }
    },

    /**
     * 展示粤康码
     */
    onShowHealthCode() {
      console.log(this.ticketList)
      this.$refs.healthInfo.$emit('show', this.ticketList)
    }
  },
};
</script>


<style scoped lang="less">
.Value-CellClass {
  font-size: 16px;
}

.Title-CellClass {
  text-align: left;
  font-size: 0.5rem;
  line-height: 0.875rem;
}

.btn-test {
  margin-top: 1rem;
}
</style>